/**
 * Distributes widgets into rows based on the available space.
 * @param amountOfWidgets The total number of widgets.
 * @param numberOfRows The number of rows to distribute the widgets into.
 * @param widgets The array of widgets to distribute.
 * @returns An array representing the distributed widgets with one entry per row
 */
export const calculateWidgetDistribution = (amountOfWidgets: number, numberOfRows: number, widgets: React.ReactNode[]): React.ReactNode[][] => {
  const base = Math.floor(amountOfWidgets / numberOfRows)
  const remainder = amountOfWidgets % numberOfRows

  /* calculate the count of widgets per row */
  const widgetsPerRow = Array.from({ length: numberOfRows }, (_, i) => (i < numberOfRows - remainder ? base : base + 1))

  /* build the result array */
  const result: React.ReactNode[][] = []
  let index = 0
  for (const size of widgetsPerRow) {
    result.push(widgets.slice(index, index + size))
    index += size
  }

  return result
}
